<template>
    <div class="content">
        <div class="title">企业风采</div>
        <div class="imgs">
            <div
                v-for="(item,index) in data"
                :key="index"
                :src="item"
                class="img"
                :style="{backgroundImage:'url('+item+')'}"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: [
                '/images/about/s_01.png',
                '/images/about/s_02.png',
                '/images/about/s_03.png',
                '/images/about/s_04.png',
                '/images/about/s_05.png',
                '/images/about/s_06.png',
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.content {
    width: 1260px;
    padding: 50px 30px 0px 30px;
    overflow: visible;

    .title {
        font-size: 25px;
        color: #333333;
    }
    .imgs {
        margin-top: 50px;
        display: flex;
        flex-wrap: wrap;

        .img {
            width: 400px;
            height: 264px;
            cursor: pointer;
            transition: all 0.3s;
            background-position: center;
            &:hover {
                transform: scale(1.1);
                z-index: 99;
            }
        }
    }
}
</style>
